<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20.638"
        height="20.441"
        viewBox="0 0 20.638 20.441"
    >
        <g
            id="Gruppe_59"
            data-name="Gruppe 59"
            transform="translate(1.25 1.25)"
        >
            <path
                id="Pfad_17"
                data-name="Pfad 17"
                d="M3278.137,541.409h-5.909v5.712"
                transform="translate(-3272.227 -541.409)"
                fill="none"
                stroke="#fff"
                stroke-width="2.5"
            />
            <path
                id="Pfad_20"
                data-name="Pfad 20"
                d="M3278.137,547.121h-5.909v-5.712"
                transform="translate(-3272.227 -529.18)"
                fill="none"
                stroke="#fff"
                stroke-width="2.5"
            />
            <path
                id="Pfad_18"
                data-name="Pfad 18"
                d="M3272.227,541.409h5.909v5.712"
                transform="translate(-3259.999 -541.409)"
                fill="none"
                stroke="#fff"
                stroke-width="2.5"
            />
            <path
                id="Pfad_19"
                data-name="Pfad 19"
                d="M3272.227,547.121h5.909v-5.712"
                transform="translate(-3259.999 -529.18)"
                fill="none"
                stroke="#fff"
                stroke-width="2.5"
            />
        </g>
    </svg>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "FullscreenIcon",
    props: {
        fillClass: {
            type: String,
            default: "fill-white",
        },
    },
});
</script>
